module.exports = __webpack_public_path__ + "img/portfolio2.2d9c5d20.png";